import React, { useContext } from "react";
import { motion } from "framer-motion";
import {
  Box,
  Grid,
  Typography,
  Chip,
  Card,
  CardContent,
  Divider,
  Alert,
  Stack,
} from "@mui/material";
import {
  Person as PersonIcon,
  LocationOn as LocationOnIcon,
  AccessTime as AccessTimeIcon,
  Autorenew as AutorenewIcon,
  Email as EmailIcon,
} from "@mui/icons-material";
import SolutionDetails from "../solutions/SolutionDetails";
import AddProposal from "../solutions/forms/AddProposal";
import ReviseProposal from "../solutions/forms/ReviseProposal";
import Implemented from "../solutions/forms/Implemented";
import AssignAdmin from "../solutions/forms/AssignAdmin";
import ReportsPreview from "../ReportsPreview";
import { AuthContext } from "../../auth/AuthContext";
import MapDirectionButton from "../../maps/MapDirectionButton";
import ViewLocationMap from "../../maps/ViewLocationMap";

const IssueDetails = ({ issue, reload, setReload }) => {
  const { currentUser } = useContext(AuthContext);
  // console.log(issue,'assigned id')
  // console.log(currentUser?.id, 'id')

  return (
    <motion.section
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      style={{ marginTop: "2rem" }}
    >
      <Grid container spacing={3}>
        {/* Left Info */}
        <Grid item xs={12} md={6}>
          <Card elevation={3} sx={{ borderRadius: 3 }}>
            <CardContent>
              <Typography variant="h6" fontWeight={700} gutterBottom color="success.main">
                Issue Information
              </Typography>
              <Divider sx={{ mb: 2 }} />

              <Typography variant="body2" gutterBottom>
                <strong>Issue ID:</strong> {issue.issue_id}
              </Typography>

              <Typography variant="body2" gutterBottom>
                <strong>Category:</strong>{" "}
                <Chip
                  label={issue.category}
                  color="success"
                  variant="outlined"
                  size="small"
                />
              </Typography>

              <Typography variant="body2" gutterBottom>
                <strong>Status:</strong>{" "}
                <Chip
                  label={issue.status}
                  color={
                    issue.status === "Resolved"
                      ? "success"
                      : issue.status === "Pending"
                      ? "warning"
                      : "info"
                  }
                  size="small"
                />
              </Typography>

              <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1 }}>
                <LocationOnIcon fontSize="small" color="action" />
                <Typography variant="body2">
                  <strong>Location:</strong> {issue.location}
                </Typography>
              </Stack>

              <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1 }}>
                <AccessTimeIcon fontSize="small" color="action" />
                <Typography variant="body2">
                  <strong>Reported:</strong>{" "}
                  {new Date(issue.timestamp).toLocaleString()}
                </Typography>
              </Stack>

              <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1 }}>
                <AutorenewIcon fontSize="small" color="action" />
                <Typography variant="body2">
                  <strong>Recurrent:</strong>{" "}
                  <Chip
                    label={issue.is_recurrent ? "Yes" : "No"}
                    color={issue.is_recurrent ? "error" : "default"}
                    size="small"
                  />
                </Typography>
              </Stack>
            </CardContent>
            <Grid container spacing={3} sx={{ m: 1 }} alignItems="center" gap={2} justifyContent={"center"} flexWrap={"wrap"}>
        <MapDirectionButton
              latitude={issue.latitude}
              longitude={issue.longitude}
            />
        <ViewLocationMap  issue={issue} />
      </Grid>
          </Card>
        </Grid>
         

        {/* Right Info */}
        <Grid item xs={12} md={6}>
          {issue.admin ? (
            <Card elevation={3} sx={{ borderRadius: 3, mb: 2 }}>
              <CardContent>
                <Typography variant="h6" fontWeight={700} gutterBottom color="success.main">
                   Authority
                </Typography>
                <Divider sx={{ mb: 2 }} />

                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                  <PersonIcon fontSize="small" color="action" />
                  <Typography variant="body2">
                    <strong>{issue.admin?.name || "N/A"}</strong> (
                    {issue.admin?.organisation || "N/A"})
                  </Typography>
                </Stack>

                <Stack direction="row" alignItems="center" spacing={1}>
                  <EmailIcon fontSize="small" color="action" />
                  <Typography variant="body2">
                    {issue.admin?.email || "N/A"} | {issue.admin?.phone || "N/A"}
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          ) : (
            <Alert severity="info" sx={{ mb: 2 }}>
              This issue has not been Tasked  to any admin yet.
            </Alert>
          )}

          {/* Conditional Actions */}
          <Box textAlign="center">
            {!!currentUser && !!issue?.solution?.assigned_to && issue?.solution?.status === "Pending" &&
              currentUser?.id === issue?.solution?.assigned_to?.user_id && (
                <AddProposal
                  reload={reload}
                  setReload={setReload}
                  solutionId={issue?.solution?.solution_id}
                />
              )}

            {issue?.solution?.status === "Needs Revision" &&
              currentUser?.id === issue?.solution?.assigned_to?.user_id && (
                <ReviseProposal
                  solutionId={issue?.solution?.solution_id}
                  reload={reload}
                  setReload={setReload}
                  revision_notes={issue?.solution?.revision_notes}
                  proposal_notes={issue?.solution?.proposal_notes}
                />
              )}

            {issue?.solution?.status === "Approved" &&
              currentUser?.id === issue?.solution?.assigned_to?.user_id && (
                <Implemented
                  reload={reload}
                  setReload={setReload}
                  solutionId={issue?.solution?.solution_id}
                />
              )}

            {!issue?.solution?.assigned_to &&
              currentUser?.id === issue?.admin?.user_id && (
                <AssignAdmin
                  reload={reload}
                  setReload={setReload}
                  issueId={issue?.issue_id}
                />
              )}
          </Box>
        </Grid>
      </Grid>
     

      {/* Map Section */}
      {/* <motion.div
        style={{ marginTop: "2rem" }}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <Typography
          variant="h6"
          fontWeight={700}
          gutterBottom
          color="success.main"
          display="flex"
          alignItems="center"
          gap={1}
        >
          <LocationOnIcon /> Location Map
        </Typography>

        <Box
          sx={{
            borderRadius: 3,
            overflow: "hidden",
            border: "1px solid #e0e0e0",
            position: "relative",
          }}
        >
          <Box sx={{ height: 320, width: "100%" }}>
            <MapView coordinates={[issue]} />
          </Box>
          <Box
            sx={{
              position: "absolute",
              bottom: 12,
              right: 12,
            }}
          >
            
          </Box>
        </Box>
      </motion.div> */}
      <Box sx={{ marginTop: "2rem" }}>

              {!!issue && (<SolutionDetails reload={reload} setReload={setReload} solution={issue?.solution} issue ={issue} />)}
      </Box>

      {/* Reports Section */}
      <motion.div
        style={{ marginTop: "2rem" }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
      >
        <Card elevation={3} sx={{ borderRadius: 3 }}>
          <Typography
            variant="h6"
            fontWeight={700}
            sx={{
              backgroundColor: "success.main",
              color: "white",
              p: 2,
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
            }}
          >
            Reports on this Issue ({issue?.reports.length})
          </Typography>
          <CardContent sx={{ p: 0 }}>
            <ReportsPreview reports={issue?.reports} />
          </CardContent>
        </Card>
      </motion.div>
    </motion.section>
  );
};

export default IssueDetails;
